// Build cache-bust: 1778350002
import { Helmet } from 'react-helmet-async'
import DealerForm from '../components/DealerForm'

/* ═══════════════════════════════════════════
   Contacts Page — SwedenSound
   ═══════════════════════════════════════════ */

const CONTACTS = {
  companyName: 'SwedenSound',
  telegram: 'https://t.me/SoundHouseMSK',
  telegramLabel: '@SoundHouseMSK',
  address: 'г. Москва, ул. Кировоградская 9к1, ТЦ Лавка, Шоурум Дом Звука',
  workHours: 'Пн–Пт: 9:00–18:00',
}

export default function ContactsPage() {
  return (
    <>
      <Helmet>
        <title>Контакты — SwedenSound</title>
        <meta name="description" content="Свяжитесь с SwedenSound. Telegram, email и адрес шоурума." />
      </Helmet>

      {/* ═══════ Hero ═══════ */}
      <section className="relative overflow-hidden text-white py-24 pt-32">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url('/backgrounds/bg-stage-venue.jpg?v=2')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#1a1a1a',
          }}
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative mx-auto max-w-ss px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-light tracking-tight">Контакты</h1>
          <p className="mt-3 text-white/60 max-w-2xl mx-auto text-lg">
            Свяжитесь с нами — мы всегда на связи
          </p>
        </div>
      </section>

      {/* ═══════ Contact Info ═══════ */}
      <section className="py-20 sm:py-28 bg-ss-gray">
        <div className="mx-auto max-w-ss px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl">
            <h2 className="text-3xl font-light text-ss-text mb-8">
              Как с нами связаться
            </h2>

            <div className="space-y-6">
              {/* Telegram */}
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-2xl bg-[#0088cc] flex items-center justify-center">
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium text-ss-muted uppercase tracking-wide">Telegram</p>
                  <a href={CONTACTS.telegram} target="_blank" rel="noopener noreferrer" className="text-lg text-ss-dark hover:text-[#0088cc] transition-colors">
                    {CONTACTS.telegramLabel}
                  </a>
                </div>
              </div>

              {/* Address */}
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-2xl bg-ss-dark flex items-center justify-center">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium text-ss-muted uppercase tracking-wide">Адрес</p>
                  <p className="text-lg text-ss-dark">{CONTACTS.address}</p>
                </div>
              </div>

              {/* Work Hours */}
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-2xl bg-ss-dark flex items-center justify-center">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium text-ss-muted uppercase tracking-wide">График работы</p>
                  <p className="text-lg text-ss-dark">{CONTACTS.workHours}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════ Dealer Form ═══════ */}
      <section className="py-20 sm:py-28 bg-white border-t border-ss-border">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-light text-ss-text">
              Хотите стать дилером?
            </h2>
            <p className="mt-3 text-ss-muted max-w-xl mx-auto">
              Заполните форму — мы рассмотрим заявку в течение 2 рабочих дней.
            </p>
          </div>
          <DealerForm />
        </div>
      </section>
    </>
  )
}
